
import Vue from 'vue'
import { PropOptions } from 'vue/types/options'
import Slider from '~/components/atoms/Slider.vue'
import { Gender } from '~/types/api/result'

export default Vue.extend({
  components: {
    Slider,
  },
  props: {
    genderType: {
      type: String,
      required: true,
    },
    gender: {
      type: Object,
      required: true,
    } as PropOptions<Gender>,
    summary: Boolean,
  },
  computed: {
    sliderBoxTypeClass() {
      return {
        'sliderBox--sex': this.genderType === 'sex',
        'sliderBox--genderIdentity': this.genderType === 'gender_identity',
        'sliderBox--genderExpression': this.genderType === 'gender_expression',
        'sliderBox--sexualOrientation': this.genderType === 'sexual_orientation',
        'sliderBox--romanticOrientation': this.genderType === 'romantic_orientation',
      }
    },
    displayPercent() {
      const maxScore = 100
      const score: number = (this.gender as Gender).score
      const type: string = (this.gender as Gender).sliderType || ''

      const f = {
        female: () => {
          return score
          // return -(score - maxScore)
        },
        male: () => {
          return score
        },
        both: () => {
          return maxScore
        },
      }

      if (type in f) {
        return f[type]()
      } else {
        return 50
      }
    },
  },
})
